import { apiClient } from '../lib/api';
import type {
  AuthorizeResponse,
  CalendarEvent,
  Connection,
} from '../types/integrations';

interface Envelope<T> {
  status: 'success';
  data: T;
}

export const learnerIntegrationsService = {
  list: () => apiClient.get<Envelope<Connection[]>>('/me/integrations'),

  startGoogleConnect: () =>
    apiClient.get<Envelope<AuthorizeResponse>>(
      '/me/integrations/google/authorize'
    ),

  disconnect: (connectionId: string) =>
    apiClient.delete<Envelope<{ id: string }>>(
      `/me/integrations/${connectionId}`
    ),

  listEvents: (from: Date, to: Date) =>
    apiClient.get<
      Envelope<{
        connected: boolean;
        connection_status?: string;
        events: CalendarEvent[];
      }>
    >('/me/integrations/google/calendar/events', {
      params: { from: from.toISOString(), to: to.toISOString() },
    }),
};
